import React from 'react';

import Button from '../Button';
import ShortText from '../ShortText';
import ImageBlurFallback from '../ImageBlurFallback';

import { CLIENT_URL_IMAGE } from '../../config.local';

import './style.css';

const CardDescriptor = ({ headingText, descriptionText }) => {
  return (
    <div className="course-card-descriptor-content">
      <p className="course-card-heading">{headingText}</p>
      <ShortText minWords={150} text={descriptionText}>
        {val => <p className="course-card-description">{val}</p>}
      </ShortText>
    </div>
  );
};

const CourseCard = ({
  className,
  onCourseClick,
  thumbnail,
  title,
  description,
  courseKey,
  position,
  buttonText = 'LEARN MORE'
}) => {
  return (
    <div
      onClick={() => onCourseClick(courseKey)}
      style={{
        animation: `slideInBottom 500ms ease ${position * 100}ms forwards`
      }}
      className={`course-card-content ${className}`}>
      <ImageBlurFallback
        src={thumbnail ? `${CLIENT_URL_IMAGE}${thumbnail}` : ''}
        alt={title}
        className="course-card-image"
      />
      <CardDescriptor headingText={title} descriptionText={description} />
      <div className="course-card-button-container">
        <Button text={buttonText} primaryFull />
      </div>
    </div>
  );
};
export default CourseCard;



// WEBPACK FOOTER //
// ./src/Components/CourseCard/index.js